import { render, staticRenderFns } from "./Producto.vue?vue&type=template&id=5d1d2224&"
import script from "./Producto.vue?vue&type=script&lang=js&"
export * from "./Producto.vue?vue&type=script&lang=js&"
import style0 from "./Producto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports